import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, input } from '@angular/core';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { completionStatusBridgeStyles, completionStatusStyleId } from './completion.status.theme';

/** The completion states from the Figma "Icon" set: pending (dashed), complete (check), resolved (outlined check: closed without the work, e.g. Not Required), not-applicable (minus). */
export type CompletionStatusState = 'pending' | 'complete' | 'resolved' | 'na';

const COMPLETION_STATUS_ICONS: Record<CompletionStatusState, string> = {
  pending: 'fa-regular fa-circle-dashed',
  complete: 'fa-solid fa-circle-check',
  resolved: 'fa-regular fa-circle-check',
  na: 'fa-regular fa-circle-minus',
};

/** Single completion-status circle icon, coloured per state from the design tokens. */
@Component({
  selector: 'wb-completion-status',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class]': '$status()',
  },
  templateUrl: './completion.status.component.html',
  styleUrls: ['./completion.status.component.less'],
})
export class CompletionStatusComponent {

  private readonly document = inject(DOCUMENT);

  public $status = input<CompletionStatusState>('pending', { alias: 'status' });
  public $size = input<number>(16, { alias: 'size' });

  protected readonly $iconClass = computed(() => COMPLETION_STATUS_ICONS[this.$status()]);

  public constructor() {

    DesignSystem.Mount(this.document, completionStatusStyleId, completionStatusBridgeStyles);
  }
}
